/* eslint-disable */
<template>
	<section class="full-height">
		<div class="smaller-heading">Buchungscode eingeben</div>
		<div class="text">
			<p>Geben Sie den Buchungcode ein, den Sie per Email oder SMS erhalten haben.</p>
			<p>Nach dem Bezahlen erhalten Sie den Zugangscode zu Ihrem Zimmer.</p>
		</div>
		<div style="margin-top:5em;">
			<div style="position:relative;    margin: 0 auto; width: 360px;">
				<div style="position:absolute;right:-150px;top:-25px;">
					<button class="pad-number" v-on:click="removeNumber()"><i class="icon ion-ios-backspace"></i></button>
				</div>
				<div class="field_wrapper">
					<input v-model="booking_code" style="border:0;" class="booking_code_field" readonly="readonly" placeholder="Code Eingeben">
				</div>
				<div class="pad-row">
					<div><button class="pad-number" v-on:click="padNumber(1)">1</button></div>
					<div><button class="pad-number" v-on:click="padNumber(2)">2</button></div>
					<div><button class="pad-number" v-on:click="padNumber(3)">3</button></div>
				</div>
				<div class="pad-row">
					<div><button class="pad-number" v-on:click="padNumber(4)">4</button></div>
					<div><button class="pad-number" v-on:click="padNumber(5)">5</button></div>
					<div><button class="pad-number" v-on:click="padNumber(6)">6</button></div>
				</div>
				<div class="pad-row">
					<div><button class="pad-number" v-on:click="padNumber(7)">7</button></div>
					<div><button class="pad-number" v-on:click="padNumber(8)">8</button></div>
					<div><button class="pad-number" v-on:click="padNumber(9)">9</button></div>
				</div>
			</div>
		</div>
		<div class="back-button">
			<button class="button" v-on:click="goBack">Zurück</button>
		</div>
	</section>
</template>
<script>
import axios from 'axios'

export default {
	name: 'IndexList',

	components: {
	},

	data () {
		return {
			booking_code: '',
			companies: [
				{'test': 'test'}
			]
		}
	},

	created () {
	},

	watch: {
	},

	methods: {

		goBack () {
			this.$router.push('/')
		},
		removeNumber () {
			this.booking_code = this.booking_code.substring(0, (this.booking_code.length - 1))
		},
		padNumber (number) {
			this.booking_code = this.booking_code + number

			if (this.booking_code.length == 6) {
				this.checkCode()
			}
		},
		checkCode () {
			axios
				.post(
					process.env.API_URL + '/booking/checkBookingCode',
					{ 'booking_code': this.booking_code }
				)
				.then(resp => {
					var data = resp.data
					if (data.status == 'OK') {
						var booking = data.booking[0]

						// booking.room.roomSetting = data.roomS#etting
						this.$store.commit('setBooking', booking)
						this.$router.push({name: 'summary'})
						console.log(resp)
					} else {

					}
				})
				.catch(err => {
					console.log(err)
				})
		}
	}
}
</script>
<style scoped>
.select-buttons {
  text-align: center;
  position: absolute;
  bottom: 2em;
  left:0;
  right:0;
}
.booking_code_field {
  font-size: 2em;
  font-weight:bold;
  border:0;
  width:100%;
  margin-bottom:1em;
  border-bottom:2px solid black;
  text-align: center;
  background:transparent;
  padding: 0.5em;
  background:#ffffff;
}
.field_wrapper {
text-align: center;
}
.smaller-heading {
  margin-top:1em;
}
button.pad-number {
width: 100px;
    height: 100px;
    background: transparent;
    /* border: 3px solid #00000073; */
    border: 0;
    background: #ffffff;
    font-size: 38px;
    margin: 10px;
    font-weight: bold;
    border-radius: 75px;
    color: #000000cc;
}
.pad-row>div {
    float: left;
}
.pad-row {
    clear: both;
}
</style>



// WEBPACK FOOTER //
// src/components/BookingCode.vue